const pillars = [
  {
    icon: 'ri-shield-check-fill',
    title: 'Fully Vetted.',
    body: 'We check licenses, insurance, and reviews so you don\'t have to. Every pro in our network is background-screened before dispatch.',
  },
  {
    icon: 'ri-timer-flash-fill',
    title: 'Rapid Dispatch.',
    body: 'Emergency routing for critical issues like leaks, broken HVACs, and storm damage. We get pros moving in minutes, not days.',
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    title: 'Transparent Quotes.',
    body: 'No surprise fees. Connect with pros who respect your budget and provide upfront pricing before any work begins.',
  },
];

export default function TrustBar() {
  return (
    <section id="why-us" className="py-20 px-6 bg-white">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#FF6B00] text-sm font-bold uppercase tracking-widest font-heading mb-2">Our Commitment</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0A2540] font-heading">
            The HomePro Dispatch Difference.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((p) => (
            <div key={p.title} className="flex flex-col items-start gap-4 p-8 rounded-2xl bg-[#F7F9FC] border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#0A2540]">
                <i className={`${p.icon} text-[#FF6B00] text-2xl`} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#0A2540] font-heading mb-2">{p.title}</h3>
                <p className="text-gray-500 text-sm font-body leading-relaxed">{p.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof bar */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-gray-100 pt-10">
          {[
            { num: '50,000+', label: 'Homeowners Served' },
            { num: '1,200+', label: 'Vetted Contractors' },
            { num: '4.9 ★', label: 'Average Rating' },
            { num: '< 4 min', label: 'Average Dispatch Time' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-3xl font-extrabold text-[#0A2540] font-heading">{stat.num}</p>
              <p className="text-sm text-gray-400 font-body mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
